export default __webpack_public_path__ + "static/media/grayman4.b18be817.jpeg";